import React from "react";
import {withRouter} from 'react-router-dom'
import {MDBIcon} from "mdbreact";



const ReusableListHeader = (props) => {
    const styleLanding = "landing-"

    const {image, heading, viewmore, redirect} = props
    return (
        <>
            <div className={styleLanding + "list-header  d-flex justify-content-between"}>
                <div className={styleLanding + "list-leftWing d-flex align-items-center justify-content-between"}>
                    <img src={image} alt={'alt'} className={styleLanding + "list-icon-main mr-3"}/>
                    <p className={styleLanding + "list-mainText mb-0"} style={window.location.pathname === "/wallet" ?{fontWeight:500,fontSize:"14px"}:null}>{heading}</p>
                </div>
                {
                    viewmore ?
                    <div className={styleLanding + "list-rightWing d-flex align-items-center"}
                                 onClick={() => props.history.push(redirect)}>
                        <p className={styleLanding + "list-viewmore mb-0"}>View All</p>
                        <MDBIcon icon="angle-right" className={"ml-2"} style={{color:"#AB8EF5"}}/>
                    </div>
                    : null
                }
            </div>
        </>
    )

};
export default withRouter(ReusableListHeader);